import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

/*

Simply provides restore configuration to the nessessary components.

*/


function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        restore: state.restore
    }
}


export function withRestore(Wrapped){

    return connect( mapStateToProps, null)(class extends React.Component<any, any>{
        
        render(){
            return <Wrapped { ...this.props } />
        }
        
    })

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/restore/index.tsx